/**
 * Created by Mark on 18/04/2017.
 */
/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Table , Collapse  , Grid, Row, Col, Clearfix } from 'react-bootstrap';
import ClassService from '../../../services/classes-service.js';
import LanguageSelector from '../../inputs/language-selector.js';
import Toggle from '../../inputs/input.toggle.component.js';
import LanguageServices from '../../../services/language-services.js';
import LanguageStore from '../../../store/language-store.js';
import Select from  'react-select';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

class LanguageSettings extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = { selectAll:true, languages:[] , selectedLanguagesJSON:{} , selectedLanguages:[] , showLanguages: true , shareTeachers:false};
        this.onLanguageToggle = this.onLanguageToggle.bind(this);
        this.onShareToggle = this.onShareToggle.bind(this);

    }

    setProps(){
        this.props.data.allLanguages      = this.state.languages.length == this.state.selectedLanguages.length;
        this.props.data.selectedlanguages = this.state.selectedLanguages;
    }
    componentDidMount() {
        LanguageServices.getAllAvailableLanguages()
    }

    componentWillMount(){
        LanguageStore.on("CHANGE" , () => {

            let __selectedLanguages = LanguageStore.getLearningLanguage();
            let selectedLanguagesJSON = {};
            let selectedLanguage = [];

            for(let idx = 0 ; idx < __selectedLanguages.length; idx++)
            {
                selectedLanguagesJSON[__selectedLanguages[idx].ietf] = __selectedLanguages[idx];
                selectedLanguage.push(__selectedLanguages[idx].ietf)
            }

            let languages = LanguageStore.getLearningLanguage();
            this.setState({languages:languages , selectedLanguages:selectedLanguage , selectedLanguagesJSON:selectedLanguagesJSON} );

        });
    }

    onLanguageToggle(){
        this.setState({ showLanguages: !this.state.showLanguages });
    }

    onShareToggle(){
        this.setState({ shareTeachers: !this.state.shareTeachers });
    }

    onLanguageSelect(language){
        this.setState({language:language})
    }

    handelSelect(language , isSelected){

        let selectedLanguages = this.state.selectedLanguages;
        if(isSelected)
        {
            selectedLanguages.push(language.ietf)
        }
        else
        {
            selectedLanguages.splice( selectedLanguages.indexOf(language.ietf), 1 );
        }

        this.setState({selectedLanguages:selectedLanguages})
    }

    isSelected(language){
        return this.state.selectedLanguagesJSON[language.ietf] != undefined;
    }

    customMultiSelect(props) {
        const { type, checked, disabled, onChange, rowIndex } = props;
        /*
         * If rowIndex is 'Header', means this rendering is for header selection column.
         */
        if (rowIndex === 'Header') {
            return (<span className="bootTable">
                        <div className="checkbox p-l-5">
                            <label>
                                <input type="checkbox"
                                       type='checkbox'
                                       name={ 'checkbox' + rowIndex }
                                       id={ 'checkbox' + rowIndex }
                                       checked={ checked }
                                       onChange={ onChange } /> <i className="input-helper"></i></label>

                        </div></span>);
        } else {


            return     <span className="bootTable">
                            <div className="checkbox p-l-5">
                                <label>
                                    <input type="checkbox"
                                           type="checkbox"
                                           checked={ checked }
                                           disabled={ disabled }
                                           onChange={ e=> onChange(e, rowIndex) }
                                           ref={ input => {
                                                if (input) {
                                                    input.indeterminate = props.indeterminate;
                                                }
                                            }
                                        } />
                                    <i className="input-helper"></i></label>
                            </div>
                        </span>;
        }
    }

    getTableData(){
        return this.state.languages.map(function(language){



            return {
                ietf:language.ietf,
                name:language.name,
            }
        });
    }

    renderlanguageImage(cell){
        return <img className="avatar-img" src={"img/flags/"+cell+".png"} alt=""/>
    }

    renderName(cell){
        return <FormattedMessage id={ "ui-"+cell } defaultMessage={ cell }/>
    }

    handelSelectAll(isSelected, rows){


        let response = [];
        let selected = [];
        for(var idx = 0 ; idx < rows.length; idx++){
            response.push(rows[idx].ietf)
        }

        let __selectedLanguages = LanguageStore.getLearningLanguage();
        let selectedLanguagesJSON = {};
        let selectedLanguage = [];

        for(let idx = 0 ; idx < __selectedLanguages.length; idx++)
        {
            selectedLanguagesJSON[__selectedLanguages[idx].ietf] = __selectedLanguages[idx];
            selectedLanguage.push(__selectedLanguages[idx].ietf)
        }


        this.setState({selectedLanguages:isSelected ? selectedLanguage : []})
        return response;
    }

    renderPaginationPanel = (props) => {
        return (
            <div id="data-table-command-footer" className="p-0 bootgrid-footer container-fluid">
                <Row className="">
                    <Col className="p-t-0 p-b-0" sm={6}>{ props.components.pageList }</Col>
                    <div className="col-sm-6 infoBar"><div className="infos"><span><FormattedMessage id={'ui-2160'} defaultMessage="Selected {bottom} of {top} languages"  values={{top: String((this.state.languages.length))  , bottom :String(this.props.data.selectedlanguages.length)}} /></span></div></div>
                </Row>
            </div>
        );
    }

    createCustomModalHeader = (closeModal, save) => {
        return (
           <div>
               sdfsdfsdfsf
               </div>
            // hideClose={ true } to hide the close button
        );

        // If you want have more power to custom the child of InsertModalHeader,
        // you can do it like following
        // return (
        //   <InsertModalHeader
        //     beforeClose={ this.beforeClose }
        //     onModalClose={ () => this.handleModalClose(closeModal) }>
        //     { ... }
        //   </InsertModalHeader>
        // );
    }

    render(){

        if(this.state.languages.length <= 0) return null;

        this.setProps();


        const tableOptions = {
            page: 1,  // which page you want to show as default

            sizePerPage: 6,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages

            paginationShowsTotal: false,
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            hideSizePerPage: true,
            paginationPanel: this.renderPaginationPanel,
            alwaysShowAllBtns: true, // Always show next and previous button
            withFirstAndLast:true,
            firstPage: '...', // First page button text
            lastPage: '...', // Last page button text
        };


        let selected = this.props.data.selectedlanguages.map(function(language){
            return language
        });

        return  <div style={{margin:-10 , paddingBottom:10}}>
            <div id="data-table-command-footer" className="p-0 p-b-10 bootgrid-footer container-fluid">
                <Row className="">
                    <div className="col-sm-12 infoBar"><div className="infos"><FormattedMessage id={'ui-2160'} defaultMessage="Selected {bottom} of {top} languages"  values={{top: String((this.state.languages.length))  , bottom :String(this.props.data.selectedlanguages.length)}} /></div></div>
                </Row>
            </div>
            <BootstrapTable selectRow={{customComponent: this.customMultiSelect , mode:'checkbox' , onSelectAll: this.handelSelectAll.bind(this) , onSelect:this.handelSelect.bind(this) , selected:selected }} csvFileName='table-export.csv' options={tableOptions} data={ this.getTableData() } keyField='ietf'  condensed pagination  bordered={ true }>
                <TableHeaderColumn col='0' width="60" colSpan='1' dataField='ietf'  dataFormat={this.renderlanguageImage} dataSort={ false }></TableHeaderColumn>
                <TableHeaderColumn col='0' colSpan='1' dataField='name'  dataFormat={this.renderName} dataSort={ false }><FormattedMessage id={ 'ui-14' } defaultMessage={ 'Name' }/></TableHeaderColumn>
            </BootstrapTable>
        </div>

    }
}



export default {
    name: <FormattedMessage id={ 'ui-847' } defaultMessage={ 'Language Settings' }/>,
    title: <FormattedMessage id={ 'ui-2007' } defaultMessage={ 'Choose the languages you would like you students to have access to.' }/>,
    onSubmit: function (done){
        done();
    },
    component: LanguageSettings
}


// WEBPACK FOOTER //
// ./src/components/wizard/create-class-steps/language-settings.js